import {BaseCreateItemStore} from "@leap4/frontend";
import {ITask} from "../../../../interfaces/ITask";
import {apiClient as axios} from "@leap4/frontend/lib/actions/apiClient";


export class CreateTaskStore extends BaseCreateItemStore<ITask>{
    entityName: string ="Task";
}
